import React, { useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { ReactComponent as AttachmentExist } from '../../../../../../assets/billpay/bill-has-attachment.svg';
import { STYLES } from './constants';
import { fileTypes } from './types';
import { useGetBillHubAttachmentData } from '../../../../hooks/useGetBillHubAttachmentData';
import { useStore } from '../../../../../../store';

interface IProps {
  documentId: string;
}
export const HasAttachment = ({ documentId } : IProps) => {
  const [shouldShowPreview, setShouldShowPreview] = useState<boolean>(false);

  const { customerId } = useStore(state => state.user);
  const getPersonalAccount = useStore(state => state.getPersonalAccount);
  const { accountExternalId } = getPersonalAccount();
  const attachmentRef = useRef<HTMLDivElement>(null);

  const {
    mutate: mutateDownload, data: downloadData, isLoading,
  } = useGetBillHubAttachmentData({ customerId, accountExternalId, documentId });

  const handleClickOutside = (event: Event) => {
    if (attachmentRef.current && !attachmentRef.current.contains(event.target as Node)) {
      setShouldShowPreview(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });
  const showHidePreview = (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
    setShouldShowPreview((prevState) => !prevState);
    mutateDownload();
  };
  return (
    <div>
      <AttachmentExist
        onClick={showHidePreview}
      />
      <div className={shouldShowPreview ? STYLES.PREVIEW_WRAPPER_SHOW : STYLES.PREVIEW_WRAPPER_HIDE}>
        {isLoading
          ? <Skeleton width='100%' height='100%' />
          : (
            <div className={STYLES.PREVIEW_CONTENT} ref={attachmentRef}>
              {downloadData?.type === fileTypes.IMAGE && <img src={downloadData.url} className='h-full w-full object-contain' alt='billsHub_attachmentPreviewImg' />}
              {downloadData?.type === fileTypes.PDF && (
                <iframe
                  data-testid='billsHub_previewPDF'
                  title='billsHub_attachmentPreviewPDF'
                  className='w-full h-full'
                  src={downloadData.url}
                />
              )}
            </div>
          )}
      </div>
    </div>
  );
};
